
import { Options } from "vue-class-component";

import { Search, List, Row, Col, DatetimePicker, Popup } from "vant";

import BaseList from "@/common/BaseList";


@Options({
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Search.name]: Search,
    [List.name]: List,
    [Row.name]: Row,
    [Col.name]: Col,
  },
})
/**我的绩效 */
export default class Achievement extends BaseList {
  reqUrl = "/zhStaff/staff/getStaffAchievement";
  _title = "我的绩效";
  finished = true;
  //   protected reqData:any={page:0,limit:10,sameMonth:new Date().getFullYear};
  data = {
    allAchievement: 0,
    serviceNum: 0,
    serviceAchievement: 0,
    packageSaleAchievement: 0,
    goodsSaleAchievement: 0,
    beautyCardAchievement: 0,
    shareholderCapitalAchievement: 0,
  };
  /**当前选中的月份 */
  private month = "";
  /**是否显示月份选择 */
  showDate = false;
  /**当前日期 */
  currentDate = new Date();
  minDate = new Date(2021, 0, 1);
  maxDate = new Date();
  mounted(): void {
    // this.user.req_data();
    var date = this.currentDate;
    this.month = (date.getMonth() + 1).toString();
    this.reqData.sameMonth = date.getFullYear() + "-" + this.month;
    this.req_items();
  }
  protected get_items(res: any) {
    console.log("绩效", res);

    this.finished = true; //当res.data为空时，结束请求，兼容请求过程中后台新增情况
    this.loading = false;
    this.data = res.data;
    if (res.data.notesList && res.data.notesList.length) {
      let list = res.data.notesList.map(this.init_item);
      this.reqData.page > 1
        ? (this.list = this.list.concat(list))
        : (this.list = list);

      this.finished = this.list.length >= res.count; //通过数量判断是否已经结束
    }
  }

  search_click() {
    this.reqData.page = 0;
    this.req_items();
  }
  protected init_item(val: any) {
    // val.thumb = AppUtil.get_thumb(val.orderMemberHeadimg, 100, 100);
    // 业绩类型：1服务业绩，2商品销售业绩，3服务销售业绩，4套餐销售业绩，5会员卡充值业绩，6股本充值业绩，10月底结算的提成金额记录
    let arr = [
      "",
      "服务业绩",
      "商品销售业绩",
      "服务销售业绩",
      "套餐销售业绩",
      "会员卡充值业绩",
      "股本充值业绩",
      "",
      "",
      "",
      "月底结算提成",
    ];
    val.title = arr[val.achievementType];
    return val;
    // console.log("val",val)
  }
  submit_date(date: Date) {
    this.month = (date.getMonth() + 1).toString();
    this.reqData.sameMonth = date.getFullYear() + "-" + this.month;
    this.reqData.page = 0;
    this.req_items();
    this.showDate=false;
    this.list=[];
    this.loading=true
  }
}
